import React, {
  useMemo,
  Fragment,
  useEffect,
  useState,
  useRef,
} from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MaterialReactTable } from "material-react-table";
import {
  dateformatConverter,
  humanReadableDate,
  humanReadableDateOnlyInDays,
} from "../../../../common/utilities/dates/dateformatConverter";
import {
  useActivateUserProfileMutation,
  useSendEmailNotiMutation,
} from "../../../../reactQueries/commonRQHooks";
import WarningAlert from "../../../../common/dialog/alerts/WarningAlert";
import useTrackUserActivity from "../../../../userActivityTracking/useTrackUserActivity";
import { useOutletContext } from 'react-router-dom';

const ViewAllClientUserForNotiDialog = ({
    open,
    setOpen,
    clientUserListFromAPI,
    clientAccOrSubAccName,
    refetchListFunc,

    setEmailNotiSuccessFromViewDialog,
    setEmailNotiErrorFromViewDialog,
    setEmailNotiLoadingFromViewDialog,

    setUserActivationSuccessFromViewDialog,
    setUserActivationErrorFromViewDialog,
    setUserActivationLoadingFromViewDialog,

    isDeactivated,
}) => {

    /**
     * Removed
Inactive
Active
Pending
     */

    const tableInstanceRef = useRef(null);
    const {refClientAccountCmsData}=useOutletContext();
    const fetchClientUsersCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientUsersList"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientUsersList"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }
    const fetchClientAccountCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccountDetails.SetupClientAccount"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';

    }
    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }
    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    const columns = useMemo(
        () => [
            {
                accessorFn: (row) => `${row.FirstName} ${row.LastName}`,
                id: 'fullName',
                header: fetchClientUsersCmsData('ClientUsersList.Name'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderName") }
            },
            {
                accessorKey: "EmailAddress",
                header: fetchClientUsersCmsData('ClientUsersList.Email'),
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderEmail") }
            },
            {
                accessorKey: "StatusDescription",
                header: fetchClientUsersCmsData('ClientUsersList.Status'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderStatus") }
            },
            {
                accessorFn: (originalRow) => {
                    const val = originalRow.IsRegistered
                    return !!val ? "Yes" : originalRow.LastLogin ? "Incomplete" : "No"
                }, //must be strings
                id: 'isRegistered',
                header: fetchClientUsersCmsData('ClientUsersList.Registration'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderRegistration") }
            },
            {
                id: 'lastLoginDate',
                header: fetchClientUsersCmsData('ClientUsersList.LastLoginDate'),
                accessorFn: (originalRow) => {
                    const data = dateformatConverter(originalRow.LastLogin, "DD MMM YYYY hh:mm A");
                    return `${data}`
                },
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderLastLoginDate") }
            },
            {
                accessorFn: (originalRow) => {
                    const val = originalRow.LastLogin

                    const indays = humanReadableDateOnlyInDays({ dateTime: val })

                    const normalHumanReadableDate = humanReadableDate({ dateTime: val })

                    if (!!indays) {
                        if (indays > 90) {
                            return normalHumanReadableDate
                        } else {
                            return `${indays} days ago`
                        }
                    } else {
                        return ""
                    }

                }, //must be strings
                id: 'lastLoginInDays',
                header: fetchClientUsersCmsData('ClientUsersList.LastLoginInDays'),
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: { placeholder: fetchClientUsersCmsData("ClientUsersList.PlaceholderLastLoginInDays") }
            },

        ],
        []
    );

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        /**clear selections */
        setRowSelection({})
    }

    const [inactiveClientUserIdList, setInactiveClientUserIdList] = useState([])
    const [activeClientUserIdList, setActiveClientUserIdList] = useState([])

    const [selectedUserEmailList, setSelectedUserEmailList] = useState([])
    const [selectedUserIdsEmailTobeSent, setSelectedUserIdsEmailTobeSent] = useState([])

    // console.log("selectedUserIdsEmailTobeSent", selectedUserIdsEmailTobeSent)

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    // console.log("rowSelection", Object.keys(rowSelection))

    useEffect(() => {
        if (!!tableInstanceRef.current) {

            let inactiveUserIds = [];
            let activeUserIds = [];
            let emailList = [];
            let userIdsEmailTobeSent = []

            tableInstanceRef.current
                .getSelectedRowModel()
                .rows.forEach((eachSelectedRowModel) => {
                    userIdsEmailTobeSent.push(eachSelectedRowModel.original?.Id)
                    if (eachSelectedRowModel.original.StatusDescription === "Active") {
                        activeUserIds.push(eachSelectedRowModel.original?.Id);
                    } else {
                        inactiveUserIds.push(eachSelectedRowModel.original?.Id);
                    }
                    const email = eachSelectedRowModel.original.EmailAddress

                    emailList.push({
                        Email: email
                    })
                });
            setActiveClientUserIdList(activeUserIds)
            setInactiveClientUserIdList(inactiveUserIds)

            setSelectedUserEmailList(emailList)
            setSelectedUserIdsEmailTobeSent(userIdsEmailTobeSent)
        }
    }, [rowSelection])


    /**email noti API */
    const {
        mutate: sendEmailNotification,
        isError: isErrorOnEmailNoti,
        isLoading: isLoadingOnEmailNoti,
        isSuccess: isSuccessOnEmailNoti,
        error: errorOnEmailNoti,
    } = useSendEmailNotiMutation();

    const {
        mutate: activateUser,
        isError: isErrorOnUserActivate,
        isLoading: isLoadingOnUserActivate,
        isSuccess: isSuccessOnUserActivate,
        error: errorOnUserActivate,
    } = useActivateUserProfileMutation();

    /**sending states to parent component */
    useEffect(() => {

        setEmailNotiSuccessFromViewDialog(isSuccessOnEmailNoti)
        setEmailNotiErrorFromViewDialog(errorOnEmailNoti)
        setEmailNotiLoadingFromViewDialog(isLoadingOnEmailNoti)

        setUserActivationSuccessFromViewDialog(isSuccessOnUserActivate)
        setUserActivationErrorFromViewDialog(isErrorOnUserActivate)
        setUserActivationLoadingFromViewDialog(isLoadingOnUserActivate)
    }, [
        isSuccessOnEmailNoti,
        errorOnEmailNoti,
        isLoadingOnEmailNoti,
        isSuccessOnUserActivate,
        isErrorOnUserActivate,
        isLoadingOnUserActivate
    ])

    /**infuture we need to show pop up for success anf failure */
    useEffect(() => {
        const handleSuccess = async () => {
            if (!!isSuccessOnUserActivate || !!isSuccessOnEmailNoti) {
                /**refetch list api */
                refetchListFunc()
                /**clear all selections */
                setRowSelection({})
            }
        };
        handleSuccess();
    }, [isSuccessOnUserActivate, isSuccessOnEmailNoti])


    const [disableActivateUserButton, setDisableActivateUserButton] = useState(false)
    const [disableEmailInvitationButton, setDisableEmailInvitationButton] = useState(false)

    useEffect(() => {

        if (!!isDeactivated) {
            /**disable if acc/sub-acc deactivated */
            setDisableActivateUserButton(true)
            setDisableEmailInvitationButton(true)
        } else {
            /**disable if active users r selected or nothing is selected */
            if (!!activeClientUserIdList?.length ||
                !Object.keys(rowSelection).length) {
                setDisableActivateUserButton(true)
            } else {
                setDisableActivateUserButton(false)
            }

            /**
            * disable if nothing is selected
            */
            if (!Object.keys(rowSelection).length) {
                setDisableEmailInvitationButton(true)
            } else {
                setDisableEmailInvitationButton(false)
            }
        }

    }, [activeClientUserIdList, rowSelection, isDeactivated])

    /**tracking user Activity */
    const { trackActivity } = useTrackUserActivity()
    useEffect(() => {
        if (!!isSuccessOnUserActivate) {

            trackActivity({
                activitySuccess: !!isSuccessOnUserActivate,
                actionType: "Activated",
                itemId: inactiveClientUserIdList.toString() || "",
            })
        }

        if (!!isSuccessOnEmailNoti) {
            trackActivity({
                activitySuccess: !!isSuccessOnEmailNoti,
                actionType: "EmailInvitationSent",
                itemId: selectedUserIdsEmailTobeSent.toString() || "",
            })
        }
    }, [isSuccessOnUserActivate, isSuccessOnEmailNoti])


    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullScreen
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                {
                    !!clientAccOrSubAccName ? fetchClientAccountCmsData('ClientAccountDetails.ListOfClientUsers').replace('#CLIENT_ACC_NAME#', `${clientAccOrSubAccName}`) : fetchClientAccountCmsData('ClientAccountDetails.ListOfUsers') 
                }
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {/** if deactivated show this banner*/}
                {
                    !!isDeactivated && (
                        <Fragment>
                            <WarningAlert
                                warningMsg={
                                    fetchClientAccountCmsData('ClientAccountDetails.AccountDeactive')
                                }
                            />
                            <br />
                        </Fragment>
                    )
                }
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={clientUserListFromAPI || []}
                    layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    enableRowSelection
                    getRowId={(originalRow) => originalRow.Id}//give each row a more useful id
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                    muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonComponentCMSLabel('Common.Rowsperpage')
                    }}
                />

            </DialogContent>
            <DialogActions>
                <Button
                    type='button'
                    variant="outlined"
                    size='small'
                    onClick={() => {
                        activateUser({ body: inactiveClientUserIdList })
                    }}
                    disabled={!!disableActivateUserButton}
                >
                    {fetchClientAccountCmsData('ClientAccountDetails.ActivateUsers')}
                </Button>

                <Button
                    type='button'
                    variant="outlined"
                    size='small'
                    onClick={() => {
                        sendEmailNotification({ body: selectedUserEmailList })
                    }}
                    disabled={!!disableEmailInvitationButton}
                >
                   {fetchClientUsersCmsData('ClientUsersList.SendInvitationEmail') || fetchClientAccountCmsData('ClientUsersList.SendInvitationEmail')}
                </Button>

                <Button
                    type='button'
                    variant="outlined"
                    size='small'
                    onClick={() => {
                        handleClose()
                    }}
                >{fetchCommonComponentCMSLabel('Common.Close')}</Button>
            </DialogActions>

        </Dialog>
    )
}
export default ViewAllClientUserForNotiDialog